import React from 'react';
import { Button } from '../ui/Button';

export const Contact: React.FC = () => {
    return (
        <section id="contact" className="py-20 md:py-24 bg-white">
            <div className="container mx-auto px-6">
                <div className="max-w-5xl mx-auto bg-black text-white rounded-[2.5rem] md:rounded-[3rem] overflow-hidden flex flex-col md:flex-row shadow-2xl">
                    <div className="w-full md:w-1/2 p-10 md:p-16 flex flex-col justify-between">
                        <div>
                            <span className="text-[#11BC97] font-semibold tracking-wider uppercase mb-4 block">
                                Get Started
                            </span>
                            <h2 className="text-3xl md:text-4xl font-bold mb-6">Start Your Journey</h2>
                            <p className="text-gray-400 leading-relaxed text-sm md:text-base">
                                Schedule a free consultation with our expert team. Let's discuss your goals and how we can help you achieve them.
                            </p>
                        </div>
                        <div className="mt-10 md:mt-12 space-y-6">
                            <div>
                                <h4 className="text-xs md:text-sm text-gray-500 uppercase tracking-widest mb-1">Email</h4>
                                <p className="text-base md:text-lg">support@golengthening.com</p>
                            </div>
                        </div>
                    </div>

                    <div className="w-full md:w-1/2 bg-white p-10 md:p-16">
                        <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                                <input type="text" className="w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 focus:border-[#11BC97] focus:ring-1 focus:ring-[#11BC97] outline-none transition-all text-black" placeholder="John Doe" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                                <input type="email" className="w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 focus:border-[#11BC97] focus:ring-1 focus:ring-[#11BC97] outline-none transition-all text-black" placeholder="john@example.com" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Mobile (with area code)</label>
                                <input type="tel" className="w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 focus:border-[#11BC97] focus:ring-1 focus:ring-[#11BC97] outline-none transition-all text-black" placeholder="+1 (555) 123-4567" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Country</label>
                                <input type="text" className="w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 focus:border-[#11BC97] focus:ring-1 focus:ring-[#11BC97] outline-none transition-all text-black" placeholder="United States" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                                <textarea rows={4} className="w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 focus:border-[#11BC97] focus:ring-1 focus:ring-[#11BC97] outline-none transition-all text-black" placeholder="I'm interested in..." />
                            </div>
                            <Button className="w-full justify-center">Send Enquiry</Button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};